<template>
    <section class="calendar">
        <table class="calendar__grid">
            <thead>
                <tr class="calendar__grid__header">
                    <td class="calendar__grid__col header col-time"></td>
                    <td class="calendar__grid__col header" v-for="(h, ind) in header" :key="`h-col-${ind}`">
                        {{ h }}
                    </td>
                </tr>
            </thead>
            <tbody>
                <template v-for="time in calendarTime">
                    <tr class="calendar__grid__row" :key="`time-${time}`">
                        <td class="calendar__grid__col col-time">{{ time }}</td>
                        <td class="calendar__grid__col" :class="{ 'in-line': header.length == 1 }"
                            v-for="(coach, dayNumber) in header" :key="`h-col-${dayNumber}`">
                            <template v-for="event in eventsTemplate(time, headerType != 1 ? dayNumber + 1 : coach)">
                                <router-link :to="{ name: 'Lesson', params: { appointment_id: event.id } }"
                                    style="text-decoration: none" :key="`link-event-${time}-${dayNumber}-${event.id}`">
                                    <div class="event" :class="{ 'only-one': event.onlyOne }"
                                        :style="{ background: event.color }">
                                        <div class="event__show">
                                            <div class="name-block">
                                                <span class="name">{{ event.name }}</span>
                                            </div>
                                            <div class="room-name">{{ event.room_name }}</div>
                                        </div>
                                        <div class="event__hidden" :style="{ background: event.color }">
                                            <div class="event__top-line">
                                                <span>{{ event.start }}-{{ event.end }}</span>
                                                <div class="count">5/10</div>
                                            </div>
                                            <span class="name">{{ event.name }}</span>
                                            <div class="room-name">{{ event.room_name }}</div>
                                        </div>
                                    </div>
                                    <!-- <div style="padding: 10px">
                                    <div class="d-flex justify-space-between align-center">
                                        <div class="event-time">{{ eventParsed.start.time }} - {{ eventParsed.end.time }}
                                        </div>
                                        <div class="event-count">5/10</div>
                                    </div>
                                    <div class="event-name">{{ eventParsed.input.name }}</div>
                                </div> -->
                                </router-link>
                            </template>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </section>
</template>
<script>
export default {
    name: "calendar",
    props: {
        type: {
            typeof: Number,//1- по дням, 2- по людям
            default: 0
        },
        events: {
            typeof: Array,
            default: () => {
                return []
            }
        },
        header: {
            typeof: Array,
            default: () => {
                return []
            }
        },
        headerType: {
            typeof: Number,
            default: 1,
        },
        itemBySort: {
            typeof: String,
            default: '',
        },
        calendarTime: {
            typeof: Array,
            default: () => {
                return []
            }
        },
        customStyle: {
            typeof: Object,
            default: () => {
                return {}
            }
        }
    },
    computed: {
        gridStyle() {
            return {
                gridTemplateColumns: `131px repeat(${this.header.length}, 1fr)`,
                gap: '0px',
                ...this.customStyle,
            }
        }
    },
    data() {
        return {
            weekDayName: {
                0: 'Пн.',
                1: 'Вт.',
                2: 'Ср.',
                3: 'Чт.',
                4: 'Пт.',
                5: 'Сб.',
                6: 'Вс.',
            }
        }
    },
    methods: {
        eventsTemplate(time, day) {
            let eventsByHandD = this.events.reduce((result, event) => {
                const startTime = this.$moment(event.start).format('HH:00')
                const eventDay = this.$moment(event.start).day()
                if (this.headerType != 1) {

                    if (time == startTime && day == eventDay) {
                        return [
                            ...result,
                            {
                                ...event,
                                start: this.$moment(event.start).format('HH:mm'),
                                end: this.$moment(event.end).format('HH:mm')
                            }
                        ]
                    } else {
                        return result
                    }

                } else {
                    if (time == startTime && day == event[this.itemBySort]) {                        
                        return [
                            ...result,
                            {
                                ...event,
                                start: this.$moment(event.start).format('HH:mm'),
                                end: this.$moment(event.end).format('HH:mm')
                            }
                        ]
                    } else {
                        return result
                    }
                }

            }, [])

            if (eventsByHandD && eventsByHandD.length == 1) {
                eventsByHandD[0].onlyOne = true
            }

            return eventsByHandD

        }
    }
}
</script>
<style lang="scss">
.calendar {
    overflow-x: auto;
    width: 100%;

    &__grid {
        border-collapse: collapse;
        min-width: 100%;

        &__header {
            background: #F1F1F1;

            // display: grid;
            .col-time {
                background: #F1F1F1 !important;
            }

            .calendar__grid__col {
                padding: 10px 12px;
                color: #1A1A1A;
                font-family: 'Circe';
                font-style: normal;
                font-weight: 700;
                font-size: 13px;
                line-height: 16px;
            }
        }

        &__row {
            // display: grid;
        }

        &__col {
            vertical-align: top;
            position: relative;
            border-bottom: 1px solid #E0E0E0;

            &.in-line {
                display: flex;
                flex-wrap: wrap;

                .event {
                    min-width: 132px;
                    flex: 1;

                    &__show {
                        display: none;
                    }

                    &__hidden {
                        display: block;
                        position: relative;
                    }
                }
            }

            &:not(:last-child) {
                border-right: 1px solid #E0E0E0 !important;
            }

            &.col-time {
                padding: 10px 12px;
                color: #1A1A1A;
                font-family: 'Circe';
                font-style: normal;
                font-weight: 700;
                font-size: 13px;
                line-height: 16px;
                width: 131px;
                min-width: 131px;
                max-width: 131px;
                position: sticky;
                left: 0;
                background: #fff;
                z-index: 2;
            }

            .event {
                background: #fff;
                padding: 7px 4px;
                width: 100%;
                cursor: pointer;

                &:hover {
                    .event__hidden {
                        display: block;
                    }
                }

                &.only-one {
                    .event__show {
                        display: none;
                    }

                    .event__hidden {
                        display: block;
                        position: relative;
                        padding: 7px 4px;
                    }

                }

                &__hidden {
                    background: #fff;
                    display: none;
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    z-index: 2;
                    padding: 10px 12px;

                    &:hover {
                        display: block;
                    }

                    .name {
                        margin-bottom: 5px;
                    }

                    .event__top-line {
                        margin-bottom: 15px;
                    }
                }

                &__show {
                    .name-block {
                        -webkit-line-clamp: 2;
                        /* Число отображаемых строк */
                        display: -webkit-box;
                        /* Включаем флексбоксы */
                        -webkit-box-orient: vertical;
                        /* Вертикальная ориентация */
                        overflow: hidden;
                        // text-overflow: ellipsis;
                        // overflow: hidden;
                        // max-height: 32px;
                        // display: -webkit-box;
                        // -webkit-line-clamp: 1;
                        // -webkit-box-orient: vertical;
                        // white-space: nowrap;

                        // -webkit-line-clamp: 1;
                        // /* количество строк */
                        // -webkit-box-orient: vertical;
                        // overflow: hidden;
                        // text-overflow: ellipsis;
                    }
                }

                .name {
                    color: #1A1A1A;
                    font-family: 'Circe';
                    font-style: normal;
                    font-weight: 700;
                    font-size: 13px;
                    line-height: 16px;
                    display: block;
                }

                .room-name {
                    color: #1A1A1A;
                    font-family: 'Circe';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 10px;
                    line-height: 12px;
                }

                &__top-line {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    span {
                        font-family: 'Circe';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 10px;
                        line-height: 12px;
                        color: #1A1A1A;
                    }

                    div {
                        padding: 4px 2px;
                        background: #1A1A1A;
                        border-radius: 2px;
                        color: #fff;
                        font-family: 'Circe';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 10px;
                        line-height: 12px;
                    }
                }
            }
        }

    }


}
</style>